/**
 * Module 110 (WP-110.1) — the wallet Block Jam actually spends and earns through.
 *
 * It is the context's wallet with one addition: every transaction that went
 * through is recorded on the coin-motion queue, so the Top Bar can show it at a
 * moment the player can see (`useShownBalance`). Recording here, rather than at
 * each call site, is the point (D9): a coin source or sink added later is queued
 * by construction. `bj-coin-motion.test.ts` fails if the plugin calls the
 * context's wallet directly for a credit or debit.
 *
 * Balances are never altered: `getBalance` is the real balance, which is what
 * every price and affordability check must read.
 */
export function recordingWallet(inner, queue, 
/**
 * Module 114 — told of every coin movement that actually happened (a refused
 * debit is not one), for the telemetry funnel's economy baseline.
 */
onChange) {
    return {
        getBalance: (type) => inner.getBalance(type),
        credit(type, amount, sourceId) {
            inner.credit(type, amount, sourceId);
            queue.push({ kind: 'credit', currency: type, amount, id: sourceId });
            onChange?.({ kind: 'credit', currency: type, amount, id: sourceId });
        },
        debit(type, amount, reasonId) {
            const paid = inner.debit(type, amount, reasonId);
            if (paid.ok) {
                queue.push({ kind: 'debit', currency: type, amount, id: reasonId });
                onChange?.({ kind: 'debit', currency: type, amount, id: reasonId });
            }
            return paid;
        },
    };
}
